import { ConfigProvider } from "antd";
import HomeScreen from "screen/01_Home";

const App = () => {
  return (
    <ConfigProvider>
      <HomeScreen />
    </ConfigProvider>
  );
};

export default App;
